import React from 'react';
import Form from 'react-bootstrap/Form';

export default function SearchToolbar(props) {
	const { /* isad, */ payload, orderby, setOrderby } = props;

	const handleOrderby = (order) =>
		setOrderby((prevOrder) => ({
			type: !prevOrder.order.includes(order)
				? 'asc'
				: prevOrder.type.includes('asc')
				? 'desc'
				: 'asc',
			order,
		}));

	const handleOrderbyType = (type) =>
		setOrderby((prevOrder) => ({
			...prevOrder,
			type,
		}));
	return (
		<div className='gcolstlb d-flex flex-wrap flex-row align-items-center gap-2'>
			<div className='p-0'>
				{payload.isLoading ? '...' : payload.total} resultados
			</div>
			<div className='d-flex p-0'>|</div>
			<div className='d-flex p-0'>Ordenar por:</div>
			<div className='filter-container d-none d-md-flex p-0 gap-2'>
				<div className='filter-container p-0'>
					<div
						className={
							orderby.order.includes('sorttitle')
								? `selected p-0`
								: 'p-0'
						}
						onClick={() => handleOrderby('sorttitle')}
					>
						Título{' '}
						<span className='arrow'>
							{orderby.order.includes('sorttitle') && (
								<i
									className={
										orderby.type.includes('desc')
											? 'fas fa-caret-down'
											: 'fas fa-caret-up'
									}
								></i>
							)}
						</span>
					</div>
					<div
						className={
							orderby.order.includes('sortauthor')
								? `selected p-0`
								: 'p-0'
						}
						onClick={() => handleOrderby('sortauthor')}
					>
						Autor{' '}
						<span className='arrow'>
							{orderby.order.includes('sortauthor') && (
								<i
									className={
										orderby.type.includes('desc')
											? 'fas fa-caret-down'
											: 'fas fa-caret-up'
									}
								></i>
							)}
						</span>
					</div>
					<div
						className={
							orderby.order.includes('producers')
								? `selected p-0`
								: 'p-0'
						}
						onClick={() => handleOrderby('producers')}
					>
						Productor{' '}
						<span className='arrow'>
							{orderby.order.includes('producers') && (
								<i
									className={
										orderby.type.includes('desc')
											? 'fas fa-caret-down'
											: 'fas fa-caret-up'
									}
								></i>
							)}
						</span>
					</div>
					{/* <div
						className={orderby.order.includes('fecha') ? `selected p-0` : ''}
						onClick={() => handleOrderby('fecha')}>
						Fecha{' '}
						<span className='arrow'>
							{orderby.order.includes('fecha') && (
								<i
									className={
										orderby.type.includes('desc')
											? 'fas fa-caret-down'
											: 'fas fa-caret-up'
									}></i>
							)}
						</span>
					</div> */}
					{/* <div
						className={orderby.order.includes('tematica') ? `selected p-0` : ''}
						onClick={() => handleOrderby('tematica')}>
						Temática{' '}
						<span className='arrow'>
							{orderby.order.includes('tematica') && (
								<i
									className={
										orderby.type.includes('desc')
											? 'fas fa-caret-down'
											: 'fas fa-caret-up'
									}></i>
							)}
						</span>
					</div> */}
					{/* <div
						className={orderby.order.includes('recientes') ? `selected p-0` : ''}
						onClick={() => handleOrderby('recientes')}>
						Más recientes{' '}
						<span className='arrow'>
							{orderby.order.includes('recientes') && (
								<i
									className={
										orderby.type.includes('desc')
											? 'fas fa-caret-down'
											: 'fas fa-caret-up'
									}></i>
							)}
						</span>
					</div> */}
				</div>
			</div>
			<div className='filter-container d-flex d-md-none p-0'>
				<Form.Select
					onChange={(e) => handleOrderby(e.target.value)}
					value={orderby.order}
				>
					<option value='codRef'>Ordenar por</option>
					<option value='sortauthor'>Autor</option>
					<option value='sorttitle'>Título</option>
					<option value='producers'>Productor</option>
					{/* <option value='fecha'>Fecha</option> */}
					{/* <option value='tematica'>Temática</option> */}
					{/* <option value='recientes'>Más recientes</option> */}
				</Form.Select>
				<Form.Select
					onChange={(e) => handleOrderbyType(e.target.value)}
				>
					<option value='asc'>Ascendente</option>
					<option value='desc'>Descendente</option>
					{/* <option value='fecha'>Fecha</option> */}
					{/* <option value='tematica'>Temática</option> */}
					{/* <option value='recientes'>Más recientes</option> */}
				</Form.Select>
			</div>
			{!orderby.order.includes('codRef') && (
				<div
					className='d-flex p-0 ms-auto'
					type='button'
					onClick={() => handleOrderby('codRef')}
				>
					Limpiar Filtro
				</div>
			)}
		</div>
	);
}
